(function (app) {

    OpenDayDetailsModalController.$inject = ["$scope", "TSToastService", "modalData", "hUser", "userServices", "interviewBankDataService", "$state", "$modal", "userPermissions", "$q"];
    function OpenDayDetailsModalController ($scope, TSToastService, modalData, hUser, userServices, interviewBankDataService, $state, $modal, userPermissions, $q) {

        var MODAL_SELECTOR = '#openday-details-modal';

        $scope.allInterviewSets = modalData.allInterviewSets;

        var getContextBrand = function () {
            var brand = hUser.getUserContext();

            return {
                id: brand.brand_id,
                type: brand.brand_type
            };
        };

        $scope.onViewChange = function (view) {
            $scope.view = view;

            if (view === $scope.VIEWS.CANDIDATES) {
                scrollToManifestDate();
            }
        };

        $scope.showSpeedyScreenItem = function (application) {
            if (application.mode === "APPLICATION_MOVED") {
                modalData.showMovedApplicationAlert(application.user.first_name);
            } else if (application.can_manage) {
                setTimeout(function(){
                    $scope.$hide();
                }, 1);
                modalData.showSpeedyScreenItem(application.user.id, application.application_id, $scope.applications, '#manifest-open-day-details-speedy-screen');
            }
        };

        var openInterviewTemplatesModal = function (application, preStarted) {

            $modal({
                controller: 'StartInterviewEvaluationModal',
                controllerAs: 'startInterviewEvaluationModal',
                templateUrl: '../hmodules/interview-bank/modals/start-interview/start-interview-evaluation.modal.html',
                show: true,
                backdrop: 'static',
                resolve: {
                    modalData: function () {
                        return {
                            brandId: application.job.brand.id,
                            applicationId: application.application_id,
                            jobId: application.job.id,
                            evaluationType: 'JOB',
                            positionName: application.job.alias_position || application.job.position.name,
                            positionCode: application.job.position.code,
                            preStarted: preStarted
                        }
                    },
                    startEvaluation: function () {
                        return function (evaluationId) {
                            $scope.close();
                            startEvaluation(application.job.brand.id, application.application_id, evaluationId, application.job.id);
                        }
                    }
                }
            });
        };

        var showInterviewResults = function (brandId, applicationId, jobId) {

            $state.go('appLayout.harriSH.interview-results', {
                applicationId: applicationId,
                evaluationType: 'JOB',
                jobId: jobId
            });
        };


        var startEvaluation = function (brandId, applicationId, evaluationId, jobId) {

            $state.go('appLayout.harriSH.interview-answers', {
                applicationId: applicationId,
                evaluationId: evaluationId,
                jobId: jobId,
                jobBrandId: brandId,
            });
        };

        $scope.onNoteAdded = function (application) {
            application.showTakeNote = false;
        };

        $scope.doAction = function (action, app) {

            if (app.mode === "APPLICATION_MOVED") {
                modalData.showMovedApplicationAlert(app.user.first_name);
                return;
            }

            switch (action) {
                case $scope.MANIFEST_ACTIONS.TAKE_NOTE:
                    app.showTakeNote = !app.showTakeNote;
                    break;

                case $scope.MANIFEST_ACTIONS.START_INTERVIEW:

                    if (
                        app.question_bank_status &&
                        app.question_bank_status.interviewer_evaluation &&
                        app.question_bank_status.interviewer_evaluation.id
                    ) {
                        var brandId = app.job.brand.id;
                        var applicationId = app.application_id;
                        var evaluationId = app.question_bank_status.interviewer_evaluation.id;
                        var jobId = app.job.id;

                        $scope.close();
                        startEvaluation(brandId, applicationId, evaluationId, jobId);
                    }
                    else {
                        if (
                            app.question_bank_status &&
                            app.question_bank_status.status &&
                            (!app.question_bank_status.interviewer_evaluation ||
                                !app.question_bank_status.interviewer_evaluation.id)
                        ) {
                            openInterviewTemplatesModal(app, true);
                        }
                        else {
                            openInterviewTemplatesModal(app);
                        }
                    }
                    break;

                case $scope.MANIFEST_ACTIONS.EVALUATION_RESULTS:

                    if (
                        (app.question_bank_status &&
                            app.question_bank_status.interviewer_evaluation &&
                            app.question_bank_status.interviewer_evaluation.status === 'FINISHED') ||
                        ($scope.isInterviewV2ServiceEnabled &&
                            $scope.interviewSet.interviewer_ids.indexOf($scope.loggedInUserId) === -1 &&
                            (app.question_bank_status &&
                                app.question_bank_status.status === 'INTERVIEWED'))
                    ) {
                        $scope.close();
                        showInterviewResults(app.job.brand.id, app.application_id, app.job.id);
                    }
                    break;

                case $scope.MANIFEST_ACTIONS.NO_SHOW_YES:

                    app.updatingStatus = true;

                    InterviewV2API.updateInterviewSetAttendance(
                        app.job.brand.id,
                        app.job.id,
                        $scope.interviewSet.id,
                        app.application_id,
                        $scope.ATTENDANCES.NO_SHOW_NOTIFIED.status
                    )
                        .then(function (data) {
                            app.updatingStatus = false;
                            app.attendance = $scope.ATTENDANCES.NO_SHOW_NOTIFIED.status;
                            $scope.$digest();
                        })
                        .catch(function (err) {
                            if (err.status === 422) {
                                    HNotifications.show({
                                        title: $filter('translate')("Error"),
                                        desc: $filter('translate')("Error in updating"),
                                        icon: "fa-times-circle",
                                        type: "danger"
                                    });
                            } else {
                                console.error(err);
                            }
                        });
                    break;

                case $scope.MANIFEST_ACTIONS.NO_SHOW_NO:

                    app.updatingStatus = true;

                    InterviewV2API.updateInterviewSetAttendance(
                        app.job.brand.id,
                        app.job.id,
                        $scope.interviewSet.id,
                        app.application_id,
                        $scope.ATTENDANCES.NO_SHOW_NOT_NOTIFIED.status
                    )
                        .then(function (data) {
                            app.attendance = $scope.ATTENDANCES.NO_SHOW_NOT_NOTIFIED.status;
                            app.updatingStatus = false;
                            $scope.$digest();
                        })
                        .catch(function (err) {
                            if (err.status === 422) {
                                HNotifications.show({
                                    title: $filter('translate')("Error"),
                                    desc: $filter('translate')("Error in updating"),
                                    icon: "fa-times-circle",
                                    type: "danger"
                                });
                            } else {
                                console.error(err);
                            }
                        });

                    break;

                case $scope.MANIFEST_ACTIONS.NO_SHOW:

                    app.attendance = $scope.ATTENDANCES.NO_SHOW.status;

                    break;

                case $scope.MANIFEST_ACTIONS.CHECK_IN:

                    app.updatingStatus = true;

                    InterviewV2API.updateInterviewSetAttendance(
                        app.job.brand.id,
                        app.job.id,
                        $scope.interviewSet.id,
                        app.application_id,
                        $scope.ATTENDANCES.CHECK_IN.status
                    )
                        .then(function (data) {
                            app.attendance = $scope.ATTENDANCES.CHECK_IN.status;
                            app.updatingStatus = false;
                            $scope.$digest();
                        })
                        .catch(function (err) {
                            if (err.status === 422) {
                                HNotifications.show({
                                    title: $filter('translate')("Error"),
                                    desc: $filter('translate')("Error in updating"),
                                    icon: "fa-times-circle",
                                    type: "danger"
                                });
                            } else {
                                console.error(err);
                            }
                        });

                    break;
            }

        };

        $scope.VIEWS = {
            GENERAL: 'GENERAL',
            CANDIDATES: 'CANDIDATES'
        };

        $scope.ATTENDANCES = {
            NO_SHOW_NOT_NOTIFIED: {
                icon: 'fa-times',
                message: $filter("translate")("No Show"),
                status: "NO_SHOW_NOT_NOTIFIED"
            },
            NO_SHOW_NOTIFIED: {
                icon: 'fa-exclamation-circle',
                message: $filter("translate")("Notified No Show"),
                status: "NO_SHOW_NOTIFIED"
            },
            CHECK_IN: {
                icon: 'fa-check-circle',
                message: $filter("translate")("Checked In"),
                status: "CHECK_IN"
            },
            NO_SHOW: {
                icon: '',
                message: $filter("translate")("Were you notified?"),
                status: "NO_SHOW"
            }
        };

        $scope.MANIFEST_ACTIONS = {
            TAKE_NOTE: "TAKE_NOTE",
            NO_SHOW_YES: "NO_SHOW_YES",
            NO_SHOW_NO: "NO_SHOW_NO",
            NO_SHOW: "NO_SHOW",
            CHECK_IN: "CHECK_IN",
            DETAILS: "DETAILS",
            START_INTERVIEW: "START_INTERVIEW",
            EVALUATION_RESULTS: "EVALUATION_RESULTS"
        };

        (function () {

            $scope.contextBrand = getContextBrand();

            $scope.onViewChange($scope.VIEWS.GENERAL);

            $scope.loading = true;

            $scope.hasActionPermissionOnBrand = hUser.isBrandAdmin;

            $scope.interviewSet = modalData.interviewSet;

            $scope.isInterviewV2ServiceEnabled = hUser.isInterviewV2ServiceEnabled();
            $scope.loggedInUserId = hUser.getUser().id;

            if ($scope.isInterviewV2ServiceEnabled) {
                $scope.interviewSet.interviewer_ids = [];

                for (var u in $scope.interviewSet.interviewers) {

                    var interviewerUser = $scope.interviewSet.interviewers[u];
                    $scope.interviewSet.interviewer_ids.push(interviewerUser.user_id);
                }
            }

            $scope.isOpenInterviwer = _.findIndex($scope.interviewSet.interviewers, function (interviewer) {
                return interviewer.user_id === hUser.getUser().id
            }) > -1;


            /**
             * Check if the open day still active or not to show the actions for candidates
             *
             * @type {boolean}
             */
            $scope.isOpenDayStillActive = true;

            /**
             * Loop through open day slots to check if there is still active slot
             */
            for (var i in $scope.interviewSet.slots) {
                var slot = $scope.interviewSet.slots[i];

                /**
                 * Slot end time parse and get the milliseconds to compare with now time to check if the open day is
                 * done and gone away
                 *
                 * @type {number}
                 */
                var slotEndTime = Date.parse(slot.end_time);

                /**
                 * Today end of day date
                 *
                 * @type {Date}
                 */
                var todayEndOfDayDate = new Date();

                /**
                 * Set date to end of day
                 */
                todayEndOfDayDate.setHours(23, 59, 59, 999);

                /**
                 * Today End of day time
                 *
                 * @type {number}
                 */
                var todayEndOfDayTime = todayEndOfDayDate.valueOf();

                if (slotEndTime <= todayEndOfDayTime) {
                    $scope.isOpenDayStillActive = false;
                    break;
                }
            }

            var promises = {};

            promises['isJobQuestionBankSettingsEnabled'] = interviewBankDataService.checkQuestionBankServiceSettings(modalData.brandId, 'job');

            if (modalData.source && modalData.source == 'RECRUITMENT_HUB') {
                promises['interviewSetApplications'] = InterviewV2API.getInterviewSetApplicationsV2(modalData.brandId, modalData.interviewSet.id, InterviewV2API.INTERVIEW_STATUSES.CONFIRMED);
            } else {
                promises['interviewSetApplications'] = InterviewV2API.getInterviewSetApplications(modalData.brandId, modalData.interviewSet.id, InterviewV2API.INTERVIEW_STATUSES.CONFIRMED);
            }

            $q.all(promises)
                .then(function (res) {
                    $scope.brandJobQuestionBankSettingsEnabled = res['isJobQuestionBankSettingsEnabled'];
                    var data = res['interviewSetApplications'];
                    $scope.applicationsLength = data.applications.length;
                    var applications = [];
                    if (modalData.source && modalData.source === 'RECRUITMENT_HUB') {
                        data.applications.forEach(function (app) {
                            app.application = app.application || {};
                            app.application.id = app.application_id;
                            app.application.current_bucket = app.swimlane;
                            app.brand = app.job.brand
                        });
                    }

                    var anyoneWithSlot = _.some(data.applications, function (app) {
                        return app.interview_set_slot && app.interview_set_slot.id;
                    });

                    var anyoneWithoutSlot = _.some(data.applications, function (app) {
                        return !app.interview_set_slot || !app.interview_set_slot.id;
                    });

                    $scope.groupedUI = true;

                    if (!anyoneWithSlot) {

                        applications.push({
                            candidates: data.applications,
                            show: true
                        });

                        $scope.applications = applications;
                        $scope.groupedUI = false;
                        $scope.loading = false;
                    }

                    var openDays = modalData.interviewSet.slots;
                    var todaySlot = modalData.interviewSet.todaySlot;

                    for (var s = 0; s < openDays.length; s++) {
                        applications.push({
                            id: moment(openDays[s].start_time).startOf('day').format("YYYY-MM-DD"),
                            sortBy: moment(openDays[s].start_time).startOf('day').valueOf(),
                            candidates: [],
                            show: true // openDays[s].start_time === todaySlot.start_time
                        });
                    }

                    if (anyoneWithoutSlot) {
                        applications.push({
                            id: 'Other',
                            sortBy: 'Other',
                            candidates: [],
                            show: true
                        });
                    }

                    if (data.applications && data.applications.length) {

                        for (var a = 0; a < data.applications.length; a++) {
                            var app = data.applications[a];
                            var confirmedSlot = app['interview_set_slot'];
                            var slotDay = confirmedSlot && confirmedSlot.start_time ? moment(confirmedSlot.start_time).format("YYYY-MM-DD") : 'Other';
                            var day = _.findWhere(applications, {id: slotDay});
                            app['isSlotInPast'] = confirmedSlot && moment(slotDay).isSameOrBefore(moment(), 'day');
                            day && day.candidates.push(app);
                        }
                    }

                    $scope.applications = applications;
                    $scope.loading = false;
                    setTimeout(function () {
                        $scope.$digest();
                    })
                }, function (err) {
                    console.error(err);
                });
        })();

        var scrollToManifestDate = function () {

            var scrollIfNotLoading = setInterval(function () {

                if (typeof ($scope.groupedUI) !== 'undefined') {

                    if (!$scope.groupedUI) {
                        clearInterval(scrollIfNotLoading);
                    }

                    if (!$scope.loading && $scope.groupedUI) {

                        setTimeout(function () {
                            var modalElement = $(MODAL_SELECTOR);
                            var selectedDateGroupPosition = $(modalElement).find('#group-' + modalData.selectedDate).offset().top;
                            $(modalElement).animate({scrollTop: parseInt(selectedDateGroupPosition)}, 500, 'swing');
                        }, 100);

                        clearInterval(scrollIfNotLoading);
                    }
                }
            }, 100);
        };

        $scope.close = function () {
            $scope.$hide();
        }
    }

    app.controller('OpenDayDetailsModalController', OpenDayDetailsModalController)
})(angular.module('harriApp'));
